import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      // border: '2px solid red',
      width: '43%',
      display: 'flex',
      flexDirection: 'column',
    },
    enlighten: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    form: {
      height: '530px',
      // border: '2px solid red',
      overflow: 'auto',
    },
  }),
  { index: 1 },
)

export { useStyles }
